import { render } from "./TodoFlag.vue?vue&type=template&id=b6017e34"
import script from "./TodoFlag.vue?vue&type=script&lang=js"
export * from "./TodoFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__